import React from 'react';
import { Monitor, Smartphone, Tablet, Globe } from 'lucide-react';

const deviceIcons = {
  Desktop: Monitor,
  Mobile: Smartphone,
  Tablet: Tablet,
};

function BreakdownList({ title, items, loading, colorClass }) {
  if (loading) {
    return (
      <div>
        <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">{title}</h4>
        <div className="text-gray-400 text-sm py-4 text-center">Laster...</div>
      </div>
    );
  }

  const maxValue = items?.[0]?.visitors || 1;

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">{title}</h4>
      {(!items || items.length === 0) ? (
        <div className="text-gray-400 text-sm py-4 text-center">Ingen data ennå</div>
      ) : (
        <div className="space-y-2">
          {items.map((item, i) => {
            const Icon = deviceIcons[item.name] || Globe;
            return (
              <div key={i} className="relative">
                <div
                  className={`absolute inset-y-0 left-0 ${colorClass} rounded`}
                  style={{ width: `${(item.visitors / maxValue) * 100}%` }}
                />
                <div className="relative flex items-center justify-between px-3 py-2">
                  <span className="text-sm text-gray-700 flex items-center gap-2">
                    <Icon className="h-3.5 w-3.5 text-gray-400" />
                    {item.name}
                  </span>
                  <span className="text-sm font-semibold text-gray-900">{item.visitors.toLocaleString('nb-NO')}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function TechBreakdown({ browsers, devices, loading }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <BreakdownList
          title="Nettlesere"
          items={browsers}
          loading={loading}
          colorClass="bg-purple-50"
        />
        <BreakdownList
          title="Enheter"
          items={devices}
          loading={loading}
          colorClass="bg-amber-50"
        />
      </div>
    </div>
  );
}
